// extracted by mini-css-extract-plugin
module.exports = {"section":"_2pAqJ","image":"Y-f2n","background":"_2C3Xt"};